import React from 'react';

const SvgHelp = props => (
  <svg width="1em" height="1em" viewBox="0 0 12 18" {...props}>
    <path d="M4.5 18h3v-3h-3v3zM6 0C2.685 0 0 2.685 0 6h3c0-1.65 1.35-3 3-3s3 1.35 3 3c0 3-4.5 2.625-4.5 7.5h3C7.5 10.125 12 9.75 12 6c0-3.315-2.685-6-6-6z" />
  </svg>
);

export default SvgHelp;
